<!------------------------------------------------------------------------------
  - Copyright (c) 2025. DNOTE.AI
  -
  - @project dnote.ai-Frontend
  - @author DNOTE.AI
  - @copyright DNOTE.AI All rights reserved
  ----------------------------------------------------------------------------->
<script>
export default {
	name: "SessionCleaner",
	beforeMount(){
		this.$store.commit("setLoading", true);
		this.$root['cleanSession']();
		this.$store.commit("setLoading", false);
	}
}
</script>

<template>
	<div class=""></div>
</template>

<style scoped lang="scss">

</style>